var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [
    [_c('h3', [_vm._v("Icon")]), _vm._v(" "), _c('div', {
      staticClass: "bs-docs-section"
    }, [_c('div', {
      staticClass: "bs-example"
    }, [_c('h3', [_vm._v("FontAwesome 4.0 Icons")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('n3-container', [_c('n3-row', {
      staticClass: "row-ex clearfix"
    }, _vm._l((_vm.newfont), function(font) {
      return _c('n3-column', {
        key: font,
        attrs: {
          "col": 3
        }
      }, [_c('n3-icon', {
        attrs: {
          "type": font
        }
      }), _c('span', [_vm._v(_vm._s(font))])], 1)
    })), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Web Application Icons")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('n3-row', {
      staticClass: "row-ex clearfix"
    }, _vm._l((_vm.webfont), function(font) {
      return _c('n3-column', {
        key: font,
        attrs: {
          "col": 3
        }
      }, [_c('n3-icon', {
        attrs: {
          "type": font
        }
      }), _c('span', [_vm._v(_vm._s(font))])], 1)
    })), _vm._v(" "), _c('h4', [_vm._v("Form Control Icons")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('n3-row', {
      staticClass: "row-ex clearfix"
    }, _vm._l((_vm.formfont), function(font) {
      return _c('n3-column', {
        key: font,
        attrs: {
          "col": 3
        }
      }, [_c('n3-icon', {
        attrs: {
          "type": font
        }
      }), _c('span', [_vm._v(_vm._s(font))])], 1)
    })), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Currency Icons")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('n3-row', {
      staticClass: "row-ex clearfix"
    }, _vm._l((_vm.currencyfont), function(font) {
      return _c('n3-column', {
        key: font,
        attrs: {
          "col": 3
        }
      }, [_c('n3-icon', {
        attrs: {
          "type": font
        }
      }), _c('span', [_vm._v(_vm._s(font))])], 1)
    })), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Text Edit Icons")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('n3-row', {
      staticClass: "row-ex clearfix"
    }, _vm._l((_vm.textfont), function(font) {
      return _c('n3-column', {
        key: font,
        attrs: {
          "col": 3
        }
      }, [_c('n3-icon', {
        attrs: {
          "type": font
        }
      }), _c('span', [_vm._v(_vm._s(font))])], 1)
    })), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Directional Icons")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('n3-row', {
      staticClass: "row-ex clearfix"
    }, _vm._l((_vm.directionalfont), function(font) {
      return _c('n3-column', {
        key: font,
        attrs: {
          "col": 3
        }
      }, [_c('n3-icon', {
        attrs: {
          "type": font
        }
      }), _c('span', [_vm._v(_vm._s(font))])], 1)
    })), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Video Player Icons")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('n3-row', {
      staticClass: "row-ex clearfix"
    }, _vm._l((_vm.videofont), function(font) {
      return _c('n3-column', {
        key: font,
        attrs: {
          "col": 3
        }
      }, [_c('n3-icon', {
        attrs: {
          "type": font
        }
      }), _c('span', [_vm._v(_vm._s(font))])], 1)
    })), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Brand Icons")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('n3-row', {
      staticClass: "row-ex clearfix"
    }, _vm._l((_vm.brandfont), function(font) {
      return _c('n3-column', {
        key: font,
        attrs: {
          "col": 3
        }
      }, [_c('n3-icon', {
        attrs: {
          "type": font
        }
      }), _c('span', [_vm._v(_vm._s(font))])], 1)
    })), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Medical Icons")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('n3-row', {
      staticClass: "row-ex clearfix"
    }, _vm._l((_vm.medicalfont), function(font) {
      return _c('n3-column', {
        key: font,
        attrs: {
          "col": 3
        }
      }, [_c('n3-icon', {
        attrs: {
          "type": font
        }
      }), _c('span', [_vm._v(_vm._s(font))])], 1)
    }))], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', [_vm._v("Params")]), _vm._v(" "), _vm._m(1)])]
  ], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-html"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-icon")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"rub\"")]), _vm._v(">")]), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-icon")]), _vm._v(">")]), _vm._v("\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("type")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("size")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("size")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("color")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("color")])])])])
}]
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-08e20588", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08e20588"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/lib/markdown-compiler.js?raw!./docs/example_en/n3IconDocs.md
// module id = 857
// module chunks = 1